import React from 'react';
import {
  AccountType,
  AccountDetail,
  CommPreference,
  Maybe,
  PremiseInfo,
  Scalars,
  PspsOutage,
} from '../../__generated__/pge-types';

export interface OutageLngLat {
  lat: number;
  lng: number;
}

export type AccountWithOutageInfo = {
  isPrimaryAccount: boolean;
  hasKnownOutage: boolean;
  nestedOutageStatusCode?: number;
  description?: string;
  addressLocation?: string;
  accountNumber?: string;
  premiseInfos?: PremiseInfo[];
  encryptedPersonId?: string;
  encryptedAccountNumber?: string;
  mainCustomerName?: string;
  commPreferenceInfo?: CommPreference[];
  accountType?: AccountType;
  pspsOutage?: PspsOutage;
  isActive?: boolean;
};

export type Position = { lat: Scalars['Latitude']; lng: Scalars['Longitude'] };

export interface PSPSZoneAttributes {
  Descripción: string;
  Description: string;
  Name: string;
  Nombre: string;
  Status: PspsStatus;
}

export enum PspsStatus {
  Warning = 'Warning',
  Likely = 'Likely',
  Imminent = 'Imminent',
  InProgress = 'Happening',
  Restoration = 'Restoration in progress',
  NoAlerts = 'Inactive',
}

export interface PspsDetails {
  status: PspsStatus;
  zone: string;
}

export type RestorationStatusInfo = {
  title: string;
  description: React.ReactNode;
};

export enum RestorationStatusCodes {
  POWER_OUT,
  WERE_ON_IT,
  MORE_HELP_NEEDED,
  REPAIRS_IN_PROGRESS,
  WRAPPING_UP,
  MAINTENANCE_IN_PROGRESS,
  POWER_RESTORED_PLANNED,
  MAINTENANCE_PLANNED,
}

export enum DefaultViewParamState {
  NOTIFICATION = 'NOTIFICATION',
  REPORT_OUTAGE = 'REPORT_OUTAGE',
  MY_POWER_IS_ON = 'MY_POWER_IS_ON',
  MY_OUTAGE_HISTORY = 'MY_OUTAGE_HISTORY',
}
